export default "__VITE_ASSET__BspeJKN4__"